import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=ba65caa4&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=ba65caa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba65caa4",
  null
  
)

export default component.exports